import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../../helpers';

export const Wrapper = styled.div`
  height: 100%;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles?.elements?.wrapper)}
`;
